import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import DataGrid from "@dtci/spellbook/DataGrid";
import styles from "../../../../components/AGGrid/details-table.module.scss";
import { JobStatusModal } from "../modal/status";
import { useAgGridApi } from "tap/components/AGGrid/hooks.js";
import { useUpdateEngineGridUtils } from "./utils/gridUtils";
import { useUpdateEngineActions } from "tap/store/updateEngine/updateEngine.js";
import { useUpdateEngineData } from "../../hooks/useUpdateEngineData";

/**
 * UpdateEngine Grid - Displays update engine jobs with status modal.
 */
export const UpdateEngineGrid = () => {
  const agGridApi = useAgGridApi();
  const { jobs, refreshJobs } = useSelector((s) => s.updateEngine);
  const { updateUpdateEngine } = useUpdateEngineActions();
  const { fetchJobs, updateEngineRange, filterForm } = useUpdateEngineData();

  const refreshJobsList = async () => {
    const data = await fetchJobs(updateEngineRange, filterForm, null, true);
    if (data) {
      updateUpdateEngine({
        jobs: data?.content,
        totalPages: data?.totalPages,
        totalItems: data?.totalElements,
        currentPage: data?.pageable?.pageNumber,
      });
    }
  };

  useEffect(() => {
    if (refreshJobs) {
      refreshJobsList();
      updateUpdateEngine({ refreshJobs: false });
    }
  }, [refreshJobs]);

  const onOpenJobViewModal = useCallback(
    (job) => {
      if (!job || !job.id) return;

      updateUpdateEngine({
        isJobViewModalOpen: true,
        selectedJob: job,
      });
    },
    [updateUpdateEngine],
  );

  const { columns } = useUpdateEngineGridUtils({
    columnHandlers: [onOpenJobViewModal],
  });

  return (
    <>
      <DataGrid
        className={styles.dataGrid}
        autoSizing
        agGrid={{
          ref: agGridApi.AgGridApiRef,
          rowData: jobs ?? [],
          suppressColumnStateReset: true,
          headerHeight: 45,
          defaultColDef: {
            wrapText: true,
            autoHeight: true,
            resizable: true,
            sortable: false,
            suppressHeaderMenuButton: true,
            cellStyle: {
              paddingTop: "10px",
              paddingBottom: "10px",
              wordBreak: "break-word",
            },
          },
          getRowId: (params) => String(params.data.id),
          suppressScrollOnNewData: true,
        }}
        bordered="none"
        columnDefs={columns}
        sortable={false}
        striped
        noResultsMessage={"No Jobs Found"}
      />
      <JobStatusModal />
    </>
  );
};
